import React, {useState} from "react";
import {Popup, Icon} from 'semantic-ui-react'
import { isEmpty } from "lodash";


const CopyFieldIcon = ({ fieldInfo }) => {
    const [textCopied, setTextCopiedVal] = useState(false);
    return (
        !isEmpty(fieldInfo) && (
          <Popup
            content={textCopied ? 'Copied!' : 'Click to copy'}
            position='top center'
            trigger={
              <Icon
                name={textCopied ? 'check circle' : 'copy'}
                className='copyToClipboard'
                style={{ color: textCopied ? '#318192' : '#867474' }}
                onClick={() => {
                  navigator.clipboard.writeText(fieldInfo)
                  setTextCopiedVal(true)
                  setTimeout(() => {
                    setTextCopiedVal(false)
                  }, 2000)
                }}
              />
            }
          />
        )
      )
}
 
export default CopyFieldIcon;